import { REGISTRATION_SUCCESS, SAVE_AUTH_DETAILS, SHOW_MODAL, SET_CHANGED_PASSWORD, ADD_NEWSLETTER, FORGOT_PASSWORD, UPDATE_PASSWORD, SAVE_ALL_COUPONS, ADD_ALL_COUPONS } from '../../constants/action-constants';

import apiConstants from '../../constants/api-constants';
import jwtDecode from 'jwt-decode';
const user = localStorage.getItem(apiConstants.userInfo);
const INIT_STATE = {
    activeUser: user ? JSON.parse(user) : null,
    verificationToken: null,
    openSignup: null,
    forgotpassword: null,
    updatePassword: null,
    changedPassword: null,
    allcoupons: [],
    addcoupons: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case REGISTRATION_SUCCESS: {
            return {
                ...state,
                verificationToken: action.payload,
                openSignup: null
            };
        }
        case SAVE_AUTH_DETAILS: {
            return {
                ...state,
                activeUser: action.payload.user
            };
        }
        case SHOW_MODAL: {
            return {
                ...state,
                openSignup: action.payload,
            };
        }
        case ADD_NEWSLETTER: {
            return {
                ...state,
                newsletteradded: action.payload,
            };
        }
        case FORGOT_PASSWORD: {
            return {
                ...state,
                forgotpassword: action.payload,
            };
        }
        case UPDATE_PASSWORD: {
            return {
                ...state,
                updatePassword: action.payload,
            };
        }
        case SET_CHANGED_PASSWORD: {
            return {
                ...state,
                changedPassword: action.payload,
                openSignup: "close"
            };
        }
        case SAVE_ALL_COUPONS: {
            return {
                ...state,
                allcoupons: action.payload,
            };
        }
        case ADD_ALL_COUPONS: {
            return {
                ...state,
                addcoupons: action.payload,
            };
        }
        default:
            return state;
    }
};
